var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDashbaord = function SvgDashbaord(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Event-page",
    transform: "translate(-52.000000, -158.000000)",
    fill: "#AAAAAA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(52.000000, 158.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,0 L5.5,0 C6.32842712,-1.52179594e-16 7,0.671572875 7,1.5 L7,7.5 C7,8.32842712 6.32842712,9 5.5,9 L1.5,9 C0.671572875,9 1.01453063e-16,8.32842712 0,7.5 L0,1.5 C-1.01453063e-16,0.671572875 0.671572875,-2.91909616e-16 1.5,0 Z M11.5,0 L15.5,0 C16.3284271,-1.52179594e-16 17,0.671572875 17,1.5 L17,3.5 C17,4.32842712 16.3284271,5 15.5,5 L11.5,5 C10.6715729,5 10,4.32842712 10,3.5 L10,1.5 C10,0.671572875 10.6715729,1.52179594e-16 11.5,0 Z M1.5,12 L5.5,12 C6.32842712,12 7,12.6715729 7,13.5 L7,15.5 C7,16.3284271 6.32842712,17 5.5,17 L1.5,17 C0.671572875,17 1.01453063e-16,16.3284271 0,15.5 L0,13.5 C-1.01453063e-16,12.6715729 0.671572875,12 1.5,12 Z M11.5,8 L15.5,8 C16.3284271,8 17,8.67157288 17,9.5 L17,15.5 C17,16.3284271 16.3284271,17 15.5,17 L11.5,17 C10.6715729,17 10,16.3284271 10,15.5 L10,9.5 C10,8.67157288 10.6715729,8 11.5,8 Z",
    id: "Combined-Shape"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDashbaord);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dashbaord.7c64b30cd1c420bc784323c3a035e3b0.svg";